import { render, staticRenderFns } from "./RedirectsTable.vue?vue&type=template&id=c150f7ce"
import script from "./RedirectsTable.vue?vue&type=script&lang=js"
export * from "./RedirectsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports